import script from "./StakingIncentivesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingIncentivesCard.vue?vue&type=script&setup=true&lang=ts"

import "./StakingIncentivesCard.vue?vue&type=style&index=0&id=37e8c239&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37e8c239"]])

export default __exports__